import { render } from "./NewDependencyField.vue?vue&type=template&id=b5ccc904"
import script from "./NewDependencyField.vue?vue&type=script&lang=js"
export * from "./NewDependencyField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__